import MIXPANEL from "./constants/mixpanel";
import mixpanel from "mixpanel-browser";
import { LOCALSTORAGE } from "./constants";
import { deleteKey, getKey, setKey } from "./storage";
import { daysRemaining, getMixpanelId, getMixpanelPackName, getMixpanelPeopleProfileProperties, getMixpanelPeopleProperties, isHelpCenterWebView, isUserloggedIn, mixpanelGetSuperProperties, setMixpanelId } from "./common";
import { logFeAnalyticsMetaIfChanged, pickStableContentPlayMixpanelProps } from "./feAnalyticsMetaLog";
import isEmpty from "lodash/isEmpty";
// import store from "../store";
// import get from "lodash/get";
// import { getDateFromString } from "./Common";

// const noop = () => { };
// const mixPanelTemp = mixpanel?.people ? mixpanel : {
//     get_distinct_id: noop,
//     track: noop,
//     unregister: noop,
//     register: noop,
//     identify: noop,
//     get_group: noop,
//     set_group: noop,
//     people: {
//         unset: noop,
//         set: noop
//     }
// };
const mixPanelTemp = mixpanel;

const MP = MIXPANEL.PARAMETER;
const STALE_PACK_SUPER_PROPERTIES = [
    MP.PACK_ID,
    MP.PACK_NAME,
    MP.PACK_PRICE,
    MP.PACK_TENURE,
    MP.PACK_TYPE,
    MP.PACK_START_DATE,
    MP.PACK_END_DATE,
    MP.PAYMENT_TYPE,
];
const STALE_IDENTITY_SUPER_PROPERTIES = [
    MP.USER_IDENTITY,
    MP.RMN,
    MP.DTH_SID,
    MP.SUBSCRIBED,
    MP.STACK,
];
// AWL-2800 / AWL-2801: omit PACK-NAME for guests on these events.
const GUEST_OMIT_PACK_NAME_EVENTS = new Set([
    MIXPANEL.EVENT.BROWSE_BY_LANGUAGE_RAIL_CLICK,
    MIXPANEL.EVENT.BROWSE_BY_GENRE_RAIL_CLICK,
    MIXPANEL.EVENT.VIEW_RAIL_CONTENT,
    MIXPANEL.EVENT.SEE_ALL_EPISODES,
    MIXPANEL.EVENT.WHATSAPP_SHARE_CLICK,
    MIXPANEL.EVENT.SHARE_CLICK
]);

/**
 * Do not `people.unset` these: backend / Engage can populate them; Akash spec treats them as BE (or as LAST-USED-AT from FE).
 * Update this list if server-side people updates use additional keys.
 */
const MIXPANEL_PEOPLE_KEYS_NEVER_UNSET = new Set(
    [
        "RMN",
        "PROFILE-ID",
        "MIXPANEL-ID",
        "DTH-SID",
        "MOENGAGE-USER-ID",
        "MOENGAGE-ID",
        "EMAIL",
        "FIRST-NAME",
        "LAST-NAME",
        "USER-NAME",
        "NAME",
        "USER-TYPE",
        "FIRST-LOGIN-DATE",
        "REGISTERED-DATE",
        "NOTIFICATIONS-ENABLED",
        "LANGUAGES-SELECTED",
        "LANGUAGE-SELECTED",
        "PACK-PAYMENT-TYPE",
        "LAST-USED-AT",
        // Mixpanel / integration reserved (often set server-side)
        "$distinctId",
        "$distinct_id",
        "$name",
        "$first_name",
        "$last_name",
        "$email",
        "$phone",
    ].concat([
        MP.SUBSCRIBED,
        MP.PACK_ID,
        MP.PACK_TYPE,
        MP.PACK_NAME,
        MP.PACK_TENURE,
        MP.PACK_PRICE,
        MP.PACK_START_DATE,
        MP.PACK_END_DATE,
        MP.DTH_SID,
        MP.C_ID,
        MP.RMN,
        MP.USER_TYPE,
    ])
);

/** Old web app used to set these on `people`; we remove them now that the profile is LAST-USED-AT only, unless protected above. */
const LEGACY_FE_ONLY_PEOPLE_PROPERTY_KEYS = [
    "SID",
    "DEVICE-1",
    "DEVICE-2",
    "DEVICE-3",
    "DEVICE-4",
    "FIRST-TIME-LOGIN",
    "BINGE-ACCOUNTS-COUNT",
    "LOGGED-IN-DEVICE-COUNT",
    "LAST-APP-USAGE-DATE",
    "DEVICE-ID",
    "$CleverTap_user_id",
];

const unsetLegacyFeOnlyPeopleProperties = () => {
    if (!mixPanelTemp?.people?.unset) {
        return;
    }
    LEGACY_FE_ONLY_PEOPLE_PROPERTY_KEYS.forEach((key) => {
        if (MIXPANEL_PEOPLE_KEYS_NEVER_UNSET.has(key)) {
            return;
        }
        try {
            mixPanelTemp.people.unset(key);
        } catch {
            // ignore: unknown property or SDK edge case
        }
    });
};

let mixPanelConfig = {

    initialData: {},

    identifyUser(_legacyFlag = false) {
        let sessionUser = {};
        try {
            sessionUser = JSON.parse(getKey(LOCALSTORAGE.USER_INFO) || "{}") || {};
        } catch (e) {
            sessionUser = {};
        }

        // Prefer backend Mixpanel id from the logged-in session (camelCase on USER_INFO).
        const hadStoredDistinctId = Boolean(getMixpanelId());
        let mixpanelId =
            sessionUser?.mixpanelId ||
            getMixpanelId() ||
            mixPanelTemp.get_distinct_id();

        if (!mixpanelId) {
            mixpanelId = mixPanelTemp.get_distinct_id();
        }

        const source = sessionUser?.mixpanelId
            ? "USER_INFO.mixpanelId"
            : hadStoredDistinctId
                ? "localStorage.mixpanelDistinctId"
                : "sdk.get_distinct_id";

        setMixpanelId(mixpanelId);

        // mixpanel.identify() is required so events + people profile share the same distinct_id.
        // register({ distinct_id }) does not replace the SDK distinct_id the way identify() does.
        if (isHelpCenterWebView()) {
            if (typeof window !== "undefined") {
                window.__MIXPANEL_LAST_IDENTIFY__ = { skipped: true, reason: "help_center_webview" };
            }
        } else {
            mixPanelTemp.identify(mixpanelId);
            const identifyPayload = {
                distinctId: mixpanelId,
                source,
                sdkDistinctId: mixPanelTemp.get_distinct_id(),
            };
            if (typeof window !== "undefined") {
                window.__MIXPANEL_LAST_IDENTIFY__ = identifyPayload;
            }
        }

        return mixpanelId;
    },


    reset() {
        mixPanelTemp?.reset();
        const distinctId = mixPanelTemp.get_distinct_id();
        setKey(LOCALSTORAGE.MIXPANEL_DISTINCT_ID, distinctId);
        return distinctId;
    },

    resetUserType() {
        const superProperties = mixpanelGetSuperProperties();
        superProperties[MIXPANEL.PARAMETER.USER_TYPE] = MIXPANEL.VALUE.GUEST;
        setKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES, superProperties);
        // Ensure stale pack fields from previously registered/logged-in sessions
        // do not continue to appear on guest events.
        if (typeof mixPanelTemp.unregister === "function") {
            STALE_PACK_SUPER_PROPERTIES.forEach((key) => mixPanelTemp.unregister(key));
            STALE_IDENTITY_SUPER_PROPERTIES.forEach((key) => mixPanelTemp.unregister(key));
        }
        mixPanelTemp?.register(superProperties);
    },

    setPeopleProperties() {
        const properties = getMixpanelPeopleProfileProperties();
        if (mixPanelTemp.people) {
            // Drop FE-only people clutter (see LEGACY_FE_*); do not touch keys in MIXPANEL_PEOPLE_KEYS_NEVER_UNSET (BE may set those).
            unsetLegacyFeOnlyPeopleProperties();
            mixPanelTemp.people.set(properties);
        }
    },

    setSuperProperties() {
        const superProperties = mixpanelGetSuperProperties();
        setKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES, superProperties);
        // Drop legacy "SID" super property (use DTH-SID for DTH only from mixpanelGetSuperProperties).
        if (typeof mixPanelTemp.unregister === "function") {
            mixPanelTemp.unregister(MIXPANEL.PARAMETER.SID);
            // register() merges and does not remove absent keys, so clear stale pack keys first.
            STALE_PACK_SUPER_PROPERTIES.forEach((key) => mixPanelTemp.unregister(key));
            STALE_IDENTITY_SUPER_PROPERTIES.forEach((key) => mixPanelTemp.unregister(key));
        }
        mixPanelTemp?.register(superProperties);
    },

    unsetSuperProperties() {
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.TS_SID);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.USER_IDENTITY);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.DEVICE_ID);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.RMN);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.C_ID);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PLATFORM);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.USER_TYPE);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.SUBSCRIBED);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_ID_SP);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_NAME_SP);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_PRICE_SP);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_TENURE_SP);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PAYMENT_TYPE);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_START_DATE);
        // mixPanelTemp.people.unset(MIXPANEL.PARAMETER.PACK_END_DATE);

        mixPanelTemp.unregister(MIXPANEL.PARAMETER.USER_IDENTITY);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.DEVICE_ID);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.RMN);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.C_ID);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PLATFORM);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.USER_TYPE);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.SUBSCRIBED);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_ID_SP);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_NAME_SP);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_PRICE_SP);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_TENURE_SP);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PAYMENT_TYPE);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_START_DATE);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.PACK_END_DATE);
        mixPanelTemp.unregister(MIXPANEL.PARAMETER.SID);

        deleteKey(LOCALSTORAGE.MIXPANEL_SUPER_PROPERTIES);
    },

    setGroup() {
        let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
        const groupKey = userInfo?.subscriberId;
        if (!isEmpty(userInfo) && groupKey) {
            mixPanelTemp?.set_group("SID", groupKey);
        }
    },

    setGroupProperties() {
        let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
        const groupKey = userInfo?.subscriberId;
        if (!isEmpty(userInfo) && groupKey) {
            let properties = getMixpanelPeopleProperties();
            mixPanelTemp?.get_group("SID", groupKey)?.unset(MIXPANEL.PARAMETER.TS_SID);
            mixPanelTemp?.get_group("SID", groupKey)?.unset(MIXPANEL.PARAMETER.C_ID);
            mixPanelTemp?.get_group("SID", groupKey)?.set(properties);
        }
    },

    profileChanges() {
        if (mixPanelTemp?.people) {
            mixPanelTemp.people.set(getMixpanelPeopleProfileProperties());
        }
    },

    subscriptionDetailChanges(currentSubs, paymentData) {
        //   console.log("subscriptionDetailChanges--",currentSubs,paymentData);
        
        let mixpanel = {
            [`${MIXPANEL.PARAMETER.PACK_NAME}`]: getMixpanelPackName(currentSubs),
            [`${MIXPANEL.PARAMETER.PACK_PRICE}`]: currentSubs?.actualPlanPrice || currentSubs?.amountValue,
            [`${MIXPANEL.PARAMETER.PACK_TENURE}`]:  currentSubs?.currentTenure || currentSubs?.planInfoChargeAndDuration+" "+currentSubs?.packDuration,
            [`${MIXPANEL.PARAMETER.PACK_ID}`]: currentSubs?.productId || '',
            [`${MIXPANEL.PARAMETER.PAYMENT_STATUS}`]: paymentData?.pstatus?.toUpperCase() || paymentData?.paymentStatus?.toUpperCase() ||'',
            [`${MIXPANEL.PARAMETER.PAYMENT_DESCRIPTION}`]:paymentData?.description ? decodeURIComponent(paymentData?.description) || '': paymentData?.message || '',
            [`${MIXPANEL.PARAMETER.ORDER_ID}`]: paymentData?.merchantRefCode || paymentData?.transactionID || '',
        }

        return mixpanel;
    },

    subscriptionDetailByBE(currentSubs, paymentData, paymentStatus) {
        //  console.log("subscriptionDetailByBE--",currentSubs, paymentStatus,paymentData);

        let mixpanel = {
            [`${MIXPANEL.PARAMETER.PACK_NAME}`]: getMixpanelPackName(currentSubs),
            [`${MIXPANEL.PARAMETER.PACK_PRICE}`]: currentSubs?.actualPlanPrice || currentSubs?.amountValue ,
            [`${MIXPANEL.PARAMETER.PACK_TENURE}`]: currentSubs?.currentTenure || currentSubs?.planInfoChargeAndDuration+" "+currentSubs?.packDuration,
            [`${MIXPANEL.PARAMETER.PACK_ID}`]: currentSubs?.productId || '',
            [`${MIXPANEL.PARAMETER.PAYMENT_STATUS}`]: paymentStatus?.paymentStatus || '',
            [`${MIXPANEL.PARAMETER.ORDER_ID}`]: paymentData?.merchantRefCode || '',
        }

        return mixpanel;
    },

    trackEvent(event, data) {
        // mixPanelTemp.track("TestEvent", { testProperty: "value" });

        let updatedData =
            data !== null && data !== undefined && typeof data === "object"
                ? { ...data }
                : {};
        const platformKey = MIXPANEL.PARAMETER.PLATFORM;
        if (
            !(platformKey in updatedData) ||
            updatedData[platformKey] === null ||
            updatedData[platformKey] === undefined ||
            updatedData[platformKey] === ""
        ) {
            const superProps = mixpanelGetSuperProperties();
            updatedData[platformKey] =
                superProps[platformKey] ?? MIXPANEL.VALUE.WEB;
        }

        let keys = Object.keys(updatedData);
        if (keys.length > 0) {
            keys.forEach((keyName) => {
                if (
                    updatedData[keyName] === null ||
                    updatedData[keyName] === "null" ||
                    updatedData === undefined
                ) {
                    updatedData[keyName] = "";
                } else {
                    updatedData[keyName] =
                        updatedData[keyName] ||
                        (updatedData[keyName] === 0 ? 0 : "");
                }
            });
        }

        if (
            !isUserloggedIn() &&
            GUEST_OMIT_PACK_NAME_EVENTS.has(event)
        ) {
            delete updatedData[MIXPANEL.PARAMETER.PACK_NAME];
        }
        //  console.log("abcd---", event, updatedData);

        if (event === MIXPANEL.EVENT.PLAY_CONTENT) {
            logFeAnalyticsMetaIfChanged(
                "mixpanel-content-play-sent",
                "mixpanel.trackEvent CONTENT-PLAY (sent)",
                { finalProperties: updatedData },
                pickStableContentPlayMixpanelProps(updatedData)
            );
        }
        // Keep LAST-USED-AT fresh from FE on every tracked event.
        mixPanelTemp.people && mixPanelTemp.people.set({ "LAST-USED-AT": new Date() });
        mixPanelTemp.track(event, updatedData);
    },

    getAnalyticsData(analytics = MIXPANEL, currentSubscription) {
        return {
            // [`${analytics.PARAMETER.PACK_NAME}`]: currentSubscription?.productName,
            // [`${analytics.PARAMETER.PACK_TYPE}`]: currentSubscription?.subscriptionPackType,
            // [`${analytics.PARAMETER.PAYMENT_TYPE}`]: currentSubscription?.paymentMode,
            // [`${analytics.PARAMETER.PAYMENT_METHOD}`]: currentSubscription?.paymentMethod,
            [`${analytics.PARAMETER.DAYS_REMAINING}`]: daysRemaining(currentSubscription?.expiryDate),
        };

    }
};

export default mixPanelConfig;
